import { style } from "@vanilla-extract/css";
import { spacing } from "@/client/ui/design-system/styles/spacing.css";
import { fontFamily } from "@/client/ui/design-system/styles/typography.css";
import { pct, px } from "@/client/utils/units";

export const container = style({
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily,
});

export const card = style({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: spacing.md,
    maxWidth: px(360),
    width: pct(90),
    padding: spacing.xl,
    textAlign: "center",
    color: "white",
});

export const title = style({
    margin: 0,
    fontSize: px(24),
    fontWeight: 600,
});

export const message = style({
    margin: 0,
    fontSize: px(14),
    opacity: 0.7,
    lineHeight: 1.5,
});

export const cta = style({
    textDecoration: "none",
    marginTop: spacing.xs,
});
